var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgClose28(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.384 5.616a1.25 1.25 0 0 0-1.768 0l-5.287 4.702c-.632.563-.949.844-1.329.844s-.697-.282-1.33-.844L7.385 5.616a1.25 1.25 0 1 0-1.768 1.768l4.702 5.287c.563.632.844.949.844 1.329s-.282.697-.844 1.33l-4.702 5.286a1.25 1.25 0 0 0 1.768 1.768l5.287-4.702c.632-.563.949-.844 1.329-.844s.697.281 1.33.844l5.286 4.702a1.25 1.25 0 0 0 1.768-1.768l-4.702-5.287c-.563-.632-.844-.949-.844-1.329s.281-.697.844-1.33l4.702-5.286a1.25 1.25 0 0 0 0-1.768Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose28);
export default __webpack_public_path__ + "static/media/close_28.ad20665f.svg";
export { ForwardRef as ReactComponent };